import { ReactNode } from 'react';

import { cx } from '@libs/classnames';
import { PageSubTitle } from '@ui/components/PageSubTitle';

import styles from './PageComplexSubTitle.module.css';

export type Props = {
  className?: string;
  title: ReactNode;
  filters?: ReactNode;
  subfilters?: ReactNode;
  actions?: ReactNode;
};

export function PageComplexSubTitle({ className, title, filters, subfilters, actions }: Props) {
  const showFiltersColumn = filters || subfilters;

  return (
    <div className={cx(styles.header, className)}>
      <span className={styles.title}>
        <PageSubTitle variant="new">{title}</PageSubTitle>
        {showFiltersColumn && (
          <span className={styles.filtersColumn}>
            {filters}
            {subfilters}
          </span>
        )}
      </span>
      {actions}
    </div>
  );
}
